import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_TECHNOLOGY = "GET_LIST_TECHNOLOGY";
export const GET_DETAIL_TECHNOLOGY = "GET_DETAIL_TECHNOLOGY";
export const UPDATE_TECHNOLOGY = "UPDATE_TECHNOLOGY";
export const SAVE_TECHNOLOGY = "SAVE_TECHNOLOGY";
export const DELETE_TECHNOLOGY = "DELETE_TECHNOLOGY";
export const SET_LIST_TECHNOLOGY = "SET_LIST_TECHNOLOGY";
export const SET_DETAIL_TECHNOLOGY = "SET_DETAIL_TECHNOLOGY";



const state = {
    technology: [],
    technologyDetail: {}
};

const getters = {
    technology(state) {
        return state.technology;
    },
    technologyDetail(state) {
        return state.technologyDetail;
    },


};

const actions = {
    [GET_LIST_TECHNOLOGY](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_TECHNOLOGY}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_TECHNOLOGY, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_TECHNOLOGY](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_TECHNOLOGY}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_TECHNOLOGY, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_TECHNOLOGY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_TECHNOLOGY}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_TECHNOLOGY](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_TECHNOLOGY}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_TECHNOLOGY](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_TECHNOLOGY}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_TECHNOLOGY](state, data) {
        state.technology = data.data;
    },
    [SET_DETAIL_TECHNOLOGY](state, data) {
        state.technologyDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};